import { useEffect } from "react";

/**
 * The role/event/team/battle selection screens navigate away with a full-page
 * `window.location.href`, so the browser freezes them into its back/forward
 * cache (bfcache) with their `submitting` lock still set to the option that was
 * just clicked. Pressing "Back" restores that frozen page WITHOUT re-running
 * effects, so `submitting` stays truthy and the `if (submitting) return` guard
 * then swallows every subsequent click — the cards look dead.
 *
 * Clearing the lock on a persisted `pageshow` (the bfcache-restore signal) makes
 * the screen usable again after "Back".
 *
 * @param {(value: null) => void} setSubmitting - the state setter for the lock.
 */
function useResetSubmittingOnRestore(setSubmitting) {
  useEffect(() => {
    const onPageShow = (e) => {
      if (e.persisted) setSubmitting(null);
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, [setSubmitting]);
}

export default useResetSubmittingOnRestore;
